import React, { useEffect } from 'react';

import { connectHits } from 'react-instantsearch-dom';
import { CompanySearchListTeaser } from '/components/company-search/components';

import { scrollToElement } from '/utilities';

const CompanySearchListInternal = ({ hits, activeHit, setActiveHit}) => {
    useEffect(() => {
        if (activeHit) {
            const element = document.querySelector(`[data-company-search-list-teaser="${activeHit.id}"]`);

            let offset = 16;
            offset = window.innerWidth >= 640 ? 16 : offset;
            offset = window.innerWidth >= 768 ? 32 : offset;
            offset = window.innerWidth >= 960 ? 48 : offset;
            offset = window.innerWidth >= 1280 ? 64 : offset;

            scrollToElement(element, offset);
        }
    }, [activeHit]);

    return (
        <div className={`ais-Hits ${activeHit ? 'has-active-hit' : ''}`}>
            <ul className="ais-Hits-list">
                {hits.map((hit) => (
                    <li className="ais-Hits-list-item" key={hit.id}>
                        <CompanySearchListTeaser
                            hit={hit}
                            active={activeHit && activeHit.id === hit.id}
                            onClick={() => { setActiveHit(hit); }}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}

const CompanySearchList = connectHits(CompanySearchListInternal);

export { CompanySearchList };
